export enum IconSize {
  xs = 12,
  sm = 16,
  buttonIcon = 20,
  md = 24,
}

export enum WebSocketEvents {
  onNewCvVideo = 'onNewCvVideo',
  newCvVideo = 'newCvVideo',
}

export enum disableCvVideoNotification {
  cvVideo = 'cv_video',
}

export enum ConsumptionAction {
  PLAY_CV_VIDEO = 'play_cv_video',
  ACCESS_CANDIDATE_CONTACTS_DATA = 'access_candidate_contacts_data',
}
